import React, { useEffect, useState } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { Provider } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';
import { asyncWithLDProvider, useFlags } from 'launchdarkly-react-client-sdk';
import { ThemeProvider } from 'styled-components';
import { theme } from '@silverrailtech/srtlibrary';
import { store } from './store';

import './styles/bootstrapCustomized.scss';
import './styles/app.css'; // eslint-disable-line
import './styles/datepicker.scss';

import routes from './routes';
import muiThemeV1 from './muiThemeV1';
import FloatingButton from './components/FloatingButton';
import ConnectedIntlProvider from './components/ConnectedIntlProvider';
import MuiPickersUtilsProviderLocalized from './components/MuiPickersUtilsProviderLocalized';
import TestModeRedBar from './utils/TestModeRedBar';
import { isDevEnvironment } from './utils';

import Maintenance from './Maintenance';

const App = () => {
	const { saMaintenance } = useFlags();

	return (
		<>
			{isDevEnvironment() && <TestModeRedBar />}
			<Provider store={store}>
				<MuiThemeProvider theme={muiThemeV1}>
					<ThemeProvider theme={theme}>
						{/* Currently using theme from Component-Library - theme not defined inside project */}
						<ConnectedIntlProvider>
							<MuiPickersUtilsProviderLocalized>
								<BrowserRouter>
									{saMaintenance ? <Route component={Maintenance} /> : routes}
									<FloatingButton />
								</BrowserRouter>
							</MuiPickersUtilsProviderLocalized>
						</ConnectedIntlProvider>
					</ThemeProvider>
				</MuiThemeProvider>
			</Provider>
		</>
	);
};

function AppWrapper() {
	const [LDProvider, setLDProvider] = useState(null);

	useEffect(() => {
		(async () => {
			const provider = await asyncWithLDProvider({
				clientSideID: process.env.LAUNCHDARKLY_SDK_CLIENT_SIDE_ID,
			});
			setLDProvider(() => provider);
		})();
	}, []);

	if (!process.env.LAUNCHDARKLY_SDK_CLIENT_SIDE_ID) return <App />;

	return LDProvider ? (
		<LDProvider>
			<App />
		</LDProvider>
	) : null;
}

export default AppWrapper;
